(function () {
    'use strict';

    angular.module('app')
        .factory('NivelEducativo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "nivel-educativo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            }
        });
    }

})();
